export default class ProductQuickshop extends Core.SectionComponent {
  constructor(el, context) {
    super(el, context);

    const { product, selectedVariant } = this.data;

    this.state = {
      product,
      selectedVariant,
    };

    this.events.register(el, 'product:variant-change', event => this._onVariantChange(event));
  }

  get optionsSelector() {
    return this.query('options-selector');
  }

  _onVariantChange(event) {
    const { variant, state } = event.detail;

    if (state !== 'unselected') {
      this._refreshProduct(variant);

      this.setState({ selectedVariant: variant });
    }
 document.dispatchEvent( new CustomEvent('variantChanged', { detail: { variantId: variant.id } }) );  }

  _refreshProduct(variant) {
    // Update the price component using fetch
    fetch(`${this.data.url}/async?view=quickshop&variant=${variant.id}&section_id=${this.sectionId}`)
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const detailsBlockEl = html.querySelector('[data-type="details"]');
        const skuBlockEl = html.querySelector('[data-type="sku"]');
        const priceBlockEl = html.querySelector('[data-type="price"]');
        const inventoryStatusBlockEl = html.querySelector('[data-type="inventory_status"]');
        const buyButtonsEl = html.querySelector('[data-type="buy_buttons"]');
        const sharingEl = html.querySelector('[data-type="share"]');

        if (detailsBlockEl) {
          this.el.querySelector('[data-type="details"]').innerHTML = detailsBlockEl.innerHTML;
        }

        if (skuBlockEl) {
          this.el.querySelector('[data-type="sku"]').innerHTML = skuBlockEl.innerHTML;
        }

        if (priceBlockEl) {
          this.el.querySelector('[data-type="price"]').innerHTML = priceBlockEl.innerHTML;
        }

        if (inventoryStatusBlockEl) {
          this.el.querySelector('[data-type="inventory_status"]').innerHTML = inventoryStatusBlockEl.innerHTML;
        }

        if (buyButtonsEl) {
          this.el.querySelector('[data-type="buy_buttons"]').innerHTML = buyButtonsEl.innerHTML;
        }

        if (sharingEl) {
          this.el.querySelector('[data-type="share"]').innerHTML = sharingEl.innerHTML;
        }
      });
  }
}
